import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgClass, NgForOf, NgIf } from '@angular/common';

import { Alert, AlertService } from '../../../core/services/alert/alert.service';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    NgForOf
  ],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {
  private readonly alertService = inject(AlertService);
  protected readonly alerts = this.alertService.alerts;

  protected removeAlert(id: number): void {
    this.alertService.removeAlert(id);
  }

  protected trackById(index: number, item: Alert): number {
    return item.id;
  }
}

